import { z } from "zod";
import { filterGetBaseSchema } from "./filterGetBaseSchema";

export const pendingArchivalFilterGetSchema = z.object({
  ...filterGetBaseSchema.shape,
  filter_key: z.literal("pending_archival_filter"),
  comparison_key: z.literal("1"),
  display_name: z.string(),
  raw_value: z.boolean().optional(),
  value: z.boolean(),
  varies_by_app_group: z.literal(false),
});
